import { Box, Button, CircularProgress, TextField } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import PaperComponent from "components/common/paper-component"
import { useEffect, useState } from "react"

const SaveSettingsDialog = ({ defaultSettingName, title, open, onClose, onOK }) => {
  const [settingName, setSettingName] = useState(defaultSettingName)
  const [isSubmitting, setIsSubmitting] = useState("")

  useEffect(() => {
    setSettingName(defaultSettingName)
  }, [defaultSettingName])

  const onChange = e => {
    const val = e.target.value
    setSettingName(val)
  }

  const onKeyPress = event => {
    if (event.key === "Enter") {
      event.preventDefault()

      onOK(settingName)
    }
  }

  const handleSave = async () => {
    setIsSubmitting(true)
    await onOK(settingName)
    setIsSubmitting(false)
  }

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent dividers style={{ display: "flex", justifyContent: "center", alignItems: "center", minWidth: 400, minHeight: 100 }}>
        <TextField fullWidth label={"Custom Filter Name"} variant="outlined" value={settingName} onChange={onChange} onKeyPress={onKeyPress} />
      </DialogContent>
      <DialogActions>
        {isSubmitting ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Button id="btnCancelSettings" onClick={onClose} variant="text">
              Cancel
            </Button>
            <Button id="btnSaveSettings" type="submit" variant="contained" onClick={handleSave}>
              Save
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default SaveSettingsDialog
